import styles from "./Filters.module.css";
import { minussvg, plussvg } from "../../assets/svg/svgimages";
import SearchInput from "../Forms/SearchInput";

const Filters = ({
  manufacturers = [],
  selected,
  openManufacturer,
  openCamera,
  openLensBrand,
  toggleManufacturerMenu,
  toggleCameraMenu,
  toggleLensBrandMenu,
  handleCameraSelect,
  handleLensBrandSelect,
  handleLensSeriesSelect,
  handleSearch,
  search,
  activeFilterCount = 0,
  onResetFilters,
}) => {
  const selectedCameras = Array.isArray(selected?.cameras)
    ? selected.cameras
    : [];
  const selectedLensSeries = Array.isArray(selected?.lensSeries)
    ? selected.lensSeries
    : [];

  return (
    <div className={styles.filterform}>
      <div className={styles.header}>
        <h3 className="h3-medium">Cameras and Lenses</h3>
        {activeFilterCount > 0 && (
          <div className={styles.headerMeta}>
            <span className={styles.activeCount}>
              {activeFilterCount} active
            </span>
            <button
              type="button"
              className={styles.clearButton}
              onClick={onResetFilters}
            >
              Clear all
            </button>
          </div>
        )}
      </div>
      <div className={styles.input}>
        <SearchInput handleSearch={(e) => handleSearch(e)} search={search} />
      </div>
      <div className={styles.filters}>
        {manufacturers.map((manufacturer) => {
          const isManufacturerOpen = Array.isArray(openManufacturer)
            ? openManufacturer.includes(manufacturer.name)
            : openManufacturer === manufacturer.name;

          return (
            <div key={manufacturer.name} className={styles.filter}>
              <div
                onClick={() => toggleManufacturerMenu(manufacturer.name)}
                className={styles.brandContainer}
              >
                <button className={styles.plusButton} type="button">
                  <p>{manufacturer.name}</p>
                  {isManufacturerOpen ? minussvg : plussvg}
                </button>
              </div>

              <div
                className={`${styles.cameraMenu} ${
                  isManufacturerOpen ? styles.show : ""
                }`}
              >
                {manufacturer.cameras.map(({ camera, lensBrands }) => {
                  if (!camera?.id) {
                    return null;
                  }

                  const cameraId = camera.id.toString();
                  const isCameraOpen = Array.isArray(openCamera)
                    ? openCamera.includes(cameraId)
                    : openCamera === cameraId;
                  const isCameraChecked = selectedCameras.some(
                    (item) => item.id === camera.id
                  );
                  const cameraLabel =
                    camera.model_name || camera.brand || "Camera";

                  return (
                    <div key={camera.id} className={styles.cameraItem}>
                      <div className={styles.cameraHeader}>
                        <label className={styles.checkboxLabel}>
                          <div>
                            <input
                              type="checkbox"
                              id={`camera-${camera.id}`}
                              checked={isCameraChecked}
                              onChange={(event) =>
                                handleCameraSelect(camera, event)
                              }
                            />
                          </div>
                          <span className={styles.cameraName}>
                            {cameraLabel}
                          </span>
                        </label>
                        <button
                          className={styles.cameraToggle}
                          type="button"
                          onClick={() => toggleCameraMenu(cameraId)}
                        >
                          {isCameraOpen ? minussvg : plussvg}
                        </button>
                      </div>

                      <div
                        className={`${styles.lensMenu} ${
                          isCameraOpen ? styles.show : ""
                        }`}
                      >
                        {(Array.isArray(lensBrands) ? lensBrands : []).map(
                          (lensBrand) => {
                            if (!lensBrand?.brand) {
                              return null;
                            }

                            const brandKey = `${cameraId}-${lensBrand.brand.toLowerCase()}`;
                            const isBrandOpen = Array.isArray(openLensBrand)
                              ? openLensBrand.includes(brandKey)
                              : false;
                            const hasSeriesGroups =
                              Array.isArray(lensBrand.seriesGroups) &&
                              lensBrand.seriesGroups.length > 0;

                            const allSeriesKeys = (lensBrand.seriesGroups || []).map(sg => sg.key);
                            const isLensBrandChecked =
                              allSeriesKeys.length > 0 &&
                              allSeriesKeys.every((key) =>
                                selectedLensSeries.some((item) => item.key === key)
                              );
                            const lensBrandInputId = `lens-brand-${cameraId}-${lensBrand.brand
                              .toLowerCase()
                              .replace(/[^a-z0-9]+/g, "-")}`;

                            return (
                              <div key={lensBrand.brand} className={styles.lensItem}>
                                <div className={styles.lensHeader}>
                                  <label className={styles.checkboxLabel}>
                                    <div>
                                      <input
                                        type="checkbox"
                                        id={lensBrandInputId}
                                        checked={isLensBrandChecked}
                                        onChange={() => handleLensBrandSelect(lensBrand)}
                                      />
                                    </div>
                                    <span className={styles.lensName}>
                                      {lensBrand.brand}
                                    </span>
                                  </label>
                                  {hasSeriesGroups && (
                                    <button
                                      className={styles.assetsToggle}
                                      type="button"
                                      onClick={() => toggleLensBrandMenu(brandKey)}
                                    >
                                      {isBrandOpen ? minussvg : plussvg}
                                    </button>
                                  )}
                                </div>

                                {hasSeriesGroups && (
                                  <div
                                    className={`${styles.assetsMenu} ${
                                      isBrandOpen ? styles.show : ""
                                    }`}
                                  >
                                    {lensBrand.seriesGroups.map((lensSeries) => {
                                      const inputId = `lens-series-${cameraId}-${(
                                        lensSeries.key || ""
                                      ).replace(/[^a-z0-9]+/gi, "-")}`;
                                      const isSeriesChecked = selectedLensSeries.some(
                                        (item) => item.key === lensSeries.key
                                      );
                                      const seriesLabel =
                                        lensSeries.label ||
                                        lensSeries.series ||
                                        "Lens series";

                                      return (
                                        <div
                                          key={lensSeries.key}
                                          className={styles.assetItem}
                                        >
                                          <label className={styles.checkboxLabel}>
                                            <div>
                                              <input
                                                type="checkbox"
                                                id={inputId}
                                                checked={isSeriesChecked}
                                                onChange={() =>
                                                  handleLensSeriesSelect(lensSeries)
                                                }
                                              />
                                            </div>
                                            <span className={styles.seriesName}>{seriesLabel}</span>
                                          </label>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Filters;
